NodeList.prototype.forEach = NodeList.prototype.forEach || Array.prototype.forEach;

export default () => {
    const accordion = document.querySelectorAll('.collapse');
    accordion.forEach(e => e.addEventListener('click', function () {
        this.classList.toggle('active');
        this.querySelector('.content').classList.toggle('open');
    }));
};
